<template>
<div class="finder" v-if="models_list.length">

	<div class="field" v-if="false">
		<label>Select from list</label>
		<select v-model="active_item_i">
			<option v-for="(model,model_i) in models_list" :value="model_i">
				{{model.fullname}}
			</option>
		</select>
		<div class="select-arrow">&#9662;</div>
	</div>

	<router-link v-if="false" class="btn btn-black btn-full" @click.native="findbox_close()" :to="linkurl">{{gotoLinkTitle}}</router-link>

	<div class="field hide">
		<label>Search</label>
		<input type="text" ref="searchinput" v-model="search" placeholder="Search">
	</div>

	<input type="text" ref="searchinput" v-model="search" placeholder="Search">

	<div class="results" v-if="results && results.length">
		<template v-for="(r) in results">
			<router-link :to="'/model/'+r.slug" @click.native="findbox_close()">
				<div class="fn">{{r.first_name}}</div>
				<div class="ln">{{r.last_name}}</div>
			</router-link>
		</template>
	</div>

	<div class="no-results" v-if="search && ( !results || !results.length )">
		Sorry, no model(s) found...
	</div>

</div>
</template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
			

	},

	data(){ return {
			
		modelname: false,
		active_item_i: 0,
		search: undefined,

	}},

	computed: {

		models_list(){ return this.$store.state.findbox.models_found },

		results(){
			if( !this.models_list ) return
			var _this = this
			if( !_this.search ) return
			var s = _this.search.toLowerCase()
			var r = this.models_list.filter(function(m){
				if( !m.fullname ) return false				
				if( m.fullname.toLowerCase().indexOf( s ) >= 0 ) return true
				return false
			})
			//if( r.length > 6 ) r = r.slice(0,6)

			r = r.sort((a,b) => {
				var pts_a = Math.abs( a.fullname.length - s.length )
				var pts_b = Math.abs( b.fullname.length - s.length )
				return pts_a - pts_b
			})

			return r
		},

		active_model(){
			if( !this.models_list ) return
			if( !this.active_item_i ) return
			return this.models_list[ this.active_item_i ]
		},

		gotoLinkTitle(){	

			var m = 'model'
			if( this.active_model ) m = this.active_model.fullname

			return 'Go to ' + m

		},

		linkurl(){
			if( !this.active_model ) return '/'
			return '/model/' + this.active_model.slug
		},

	},

	methods: {

		loadModelsList()
		{
			var _this = this
			//this.spinner(1)

			if( this.models_list.length ) return		

			this.fetch('get_models_find_list', {}, { onSuccess(output){

				if( !output || !output.data || !output.data.result ) {
					_this.msg('No models found...')
					return false
				}

				var models = output.data.result

				for( var i = 0; i < models.length; i++ ) {
					models[i].fullname = helpers.getfullname(models[i])
				}
			
				_this.$store.commit('set_findbox_models_found',models)				

				_this.spinner(0)

				_this.$nextTick(() => { 
					_this.focusInput()
				})

			}, onError(error){

			}, })
		},

		getfullname: helpers.getfullname,

		focusInput(){
			if(!this.$refs.searchinput) return
			this.$refs.searchinput.focus()
		},
		

	},

	mounted(){
		
		var _this = this
		
		this.loadModelsList()

		this.$nextTick(() => { 
			_this.focusInput()
		})

	},

}
</script>



// WEBPACK FOOTER //
// src/views/findbox.vue